<template>
  <div class="login-page">
    <div class="login-form">
      <div class="loginlogo" @click="showPageHome()">
        <img src="/long1.png" class="pointer" alt="logo">
      </div>

      <p class="textzc">还没有账号？ <a href="/register" class="switch">注册账号</a></p>

      <form class="login-form-inner" @submit.prevent="handleLogin">
        <div class="form-group">
          <input type="text" id="phone" v-model="phone" required maxlength="11" placeholder="请输入手机号">
        </div>

        <div class="form-group">
          <input type="password" id="password" v-model="password" required placeholder="请输入密码">
        </div>

        <div class="form-group form-group-captcha">
          <input type="text" id="captcha" v-model="captcha" required placeholder="请输入验证码" class="captcha-input">
          <img :src="codeUrl" class="captcha-img" @click="refreshCode()" title="点击刷新验证码" alt="验证码">
        </div>

        <button type="submit" @click="handleLoginNew()" class="loginButton">登录</button>
      </form>

      <p class="textzc bottom">忘记账号密码？ <a href="#" @click.prevent="forgetPassword" class="switch">找回密码</a></p>
    </div>
  </div>
</template>

<script>
import {getCodeImg, getInfo, login} from "@/api/login";

export default {
  // name: "Login",
  data() {
    return {
      // 注册开关
      // register: true,
      type:'',
      phone: '',
      password: '',
      captcha: '',
      rememberMe: false,
      isCaptchaLogin: false, // 切换到手机验证码登录的状态
      codeUrl:'',
      uuid:"",
      loginForm:{
        username:this.phone,
        password:this.password,
        captcha:this.captcha,
        uuid:this.uuid,

      }
    };
  },

  created() {
    this.getCode();
    console.log("this.$route.params.type",this.$route.query.type);
    this.getRouthQuery()
  },
  methods: {

    getRouthQuery(){
    this.type = this.$route.query.type
    },
    push(){
      console.log("1")
      this.$router.push({name: 'home'})

    },
    //刷新验证码
    refreshCode(){
      this.getCode();
    },



    showPageHome() {
      this.$router.push({ name: 'home' });
      // window.location.reload();
      // const targetPath = "/";
      // // 检查当前路由是否与目标路径相同
      // if (this.$route.path !== targetPath) {
      //   this.$router.push({ path: targetPath }).catch((err) => {
      //     if (err.name !== "NavigationDuplicated") {
      //       console.error(err);
      //     }
      //   });
      // } else {
      //   // 如果路径相同，可以选择刷新页面或其他操作
      //   window.location.reload(); // 可选
      // }
    },
    getCode() {

      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
          this.uuid = res.uuid;
        }
      });
    },
    handleLogin(){

    },
    handleLoginNew() {
      const loginData = {
        phone: this.phone,
        password: this.password,
        captcha: this.captcha,
      };
      const userName =  this.phone
      const password =  this.password
      const captcha =  this.captcha
      const  uuid = this.uuid
      login(userName,password,captcha,uuid).then(response => {
        console.log("登录成功:", response);
        if (response.code === 200) {
          var token = response.token;
          sessionStorage.setItem("token", token);
          localStorage.setItem("token", token);
          var item = sessionStorage.getItem("token");
          //获取用户信息存下
          getInfo(token).then(response => {
            console.log("getInfo 完整响应:", JSON.stringify(response, null, 2));
            console.log("response:", response);
            console.log("response.data:", response && response.data);
            console.log("response.data.data:", response && response.data && response.data.data);
            console.log("response.data.data.user:", response && response.data && response.data.data && response.data.data.user);
            // 兼容两种响应格式
            let userInfo = response;
            if (response && response.data) {
              // 如果 response.data.data 存在，说明是 axios 原始响应
              if (response.data.data && response.data.data.user) {
                userInfo = response.data.data;
              }
              // 如果 response.data.user 存在，说明拦截器解包过了
              else if (response.data.user) {
                userInfo = response.data;
              }
            }
            console.log("最终使用的 userInfo:", userInfo);
            const userId = userInfo && userInfo.user ? userInfo.user.userId : null;
            console.log("提取的 userId:", userId);
            sessionStorage.setItem("userId", userId);
            localStorage.setItem("userId", userId);
            var userJson = JSON.stringify(userInfo && userInfo.user ? userInfo.user : {});
            sessionStorage.setItem("userInfos", userJson);
            localStorage.setItem("userInfos", userJson);
          }).catch(error => {
            console.error("getInfo 请求失败", error);
          });
          // if (this.type != null && this.type ==='1'){
          //   this.$router.push({name:'declaration'})
          // }else if (this.type != null && this.type ==='2'){
          //   this.$router.push({name:'Knowledge'})
          // }else  if (this.type != null && this.type ==='3'){
          //   this.$router.push({name:'Websocket'})
          // }else if (this.type != null && this.type ==='4'){
          //   this.$router.push({name:'inspection'})
          // }else if (this.type != null && this.type ==='5'){
          //   this.$router.push({name:'IndustryChainCopy'})
          // } else {
          //   this.$router.push({name: 'home'});
          // }

          const routeMap = {
            '1': 'declaration',
            '2': 'Knowledge',
            '3': 'intelligentAgent',
            '4': 'inspection',
            '5': 'Industry',
            '6': 'concept',
          };

          if (this.type != null && routeMap[this.type]) {
            this.$router.push({ name: routeMap[this.type] });
          } else {
            this.$router.push({ name: 'home' });
          }
        }else {
          this.getCode();
        }

      }).catch(error => {
        console.error("登录失败:", error);
        this.getCode(); // 登录失败后刷新验证码
      });
    },
    switchToRegister() {
      // 切换到注册账号的逻辑
      console.log('切换到注册');
      // 你可以在这里跳转到注册页面
    },
    switchToCaptchaLogin() {
      // 切换到手机验证码登录的逻辑
      this.isCaptchaLogin = true;
      console.log('切换到手机验证码登录');
      // 你可以在这里修改表单以显示验证码登录相关的输入项
    },
    forgetPassword() {
      // 忘记密码，找回密码的逻辑
      console.log('找回密码');
      this.$router.push({name: 'changePassword'})
      // 你可以在这里跳转到找回密码页面
    }
  }
};
</script>

<style>
.login-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/public/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 0;
}

.login-page .login-form {
  box-sizing: border-box;
  width: 520px;
  max-width: 92vw;
  background-color: #fff;
  padding: 30px 45px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.login-page .loginlogo {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.login-page .loginlogo img {
  width: 80%;
  max-width: 360px;
}

.login-page .textzc {
  margin: 0 0 20px;
  font-size: 14px;
  color: #333;
}

.login-page .textzc.bottom {
  margin: 16px 0 0;
  text-align: center;
}

.login-page .switch {
  color: #2782ff;
  text-decoration: underline;
  cursor: pointer;
}

.login-page .form-group {
  display: block;
  margin-bottom: 14px;
}

.login-page .form-group input[type="text"],
.login-page .form-group input[type="password"] {
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1px solid rgba(229, 230, 235, 1);
  border-radius: 4px;
  background: #fff;
  font-size: 14px;
  color: #333;
}

.login-page .form-group input:focus {
  outline: none;
  border-color: #2238c2;
}

.login-page .form-group-captcha {
  display: flex;
  align-items: center;
  gap: 10px;
}

.login-page .captcha-input {
  flex: 1;
  width: auto !important;
}

.login-page .captcha-img {
  width: 120px;
  height: 50px;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  object-fit: contain;
}

.login-page .loginButton {
  width: 100%;
  height: 50px;
  margin-top: 8px;
  background-color: #2238c2;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}

.login-page .loginButton:hover {
  background-color: #1a2da0;
}
</style>


